
import React, { useState, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
	Button,
	Card,
	CardHeader,
	CardBody,
	Col,
	Container,
	FormGroup,
	Input,
	Label,
	Row,
} from "reactstrap"
import { SpinnerComponent } from 'react-element-spinner'

import VehiclesService from '../../../services/VehiclesService'
import { SessionContext } from '../../../contexts/SessionProvider'
import { VehiclesContext } from '../../../contexts/VehiclesProvider'
import SiteService from '../../../services/SiteService'
import PageTitle from '../../../components/PageTitles/PageTitle'

const BusinessVehiclesSearch = () =>
{
	const { t } = useTranslation()
	const [searchRequest, setSearchRequest] = useState({ pageIndex: 0, pageSize: 15, serialNumber: '', make: '', models: [] })
	const [isBusy, setIsBusy] = React.useState(false)
	const sessionContext = useContext(SessionContext)
	const [makes, setMakes] = useState([])
	const [showAlert, setShowAlert] = React.useState(false)
	const [alertProps, setAlertProps] = useState({ title: '', message: '' })
	const [models, setModels] = useState([])
	const vehiclesContext = useContext(VehiclesContext)
	const navigate = useNavigate()
	
	useEffect(() =>
	{
		retrieveMakes()
	}, [])
	
	const retrieveMakes = () =>
	{
		setIsBusy(true)
		VehiclesService
			.getMakes(sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)
				
				setMakes(result.data.actionResult)
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}
	
	const handleSearchParameterChange = (e) =>
	{
		const { name, value} = e.target
		setSearchRequest({ ...searchRequest, [name]: value })
	}
	
	const retrieveModels = (make) =>
	{
		setIsBusy(true)
		VehiclesService
			.getModels(make, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)
				
				setModels(result.data.actionResult)
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}
	
	const handleMakesChange = (option) =>
	{
		handleSearchParameterChange(option)
		retrieveModels(option.target.value)
	}
	
	const handleModelsChange = (option) =>
	{
		const values = []
		for (let m = 0; m < option.target.selectedOptions.length; m++)
		{
			values.push(option.target.selectedOptions[m].value)
		}
		handleSearchParameterChange({ target: { name: 'models', value: values } })
	}
	
	const handleSearchVehicles = () =>
	{
		vehiclesContext.setSearchRequest(searchRequest)
		navigate('/secure/business-vehicles-listing')
	}
	
	return (
		<>
			<SpinnerComponent
				loading={ isBusy }
				position="global"
				color="#3578e5"
				secondaryColor="#f3f3f3"
				backgroundColor="#d3d3d3"
				spinnerType="circle-dots"
			/>
			<PageTitle
				heading={ t('Vehicles.Search.Title') }
				subheading=""
				icon="pe-7s-car icon-gradient bg-premium-dark"
			/>
			<Container fluid>
				<Card className="main-card mb-3">
					<CardHeader></CardHeader>
					<CardBody>
						<Row>
							<Col md="4">
								<FormGroup>
									<Label htmlFor="serialNumber">
										{ t('Vehicles.Search.Vin') }
									</Label>
									<Input
										name="serialNumber"
										type="text"
										value={ searchRequest.serialNumber }
										onChange={ handleSearchParameterChange }
									/>
								</FormGroup>
							</Col>
							<Col md="4">
								<FormGroup>
									<Label htmlFor="make">
										{ t('Vehicles.Search.Make') }
									</Label>
									<Input
										name="make"
										type="select"
										onChange={ handleMakesChange }
									>
										<option>{ '-- Select --' }</option>
										{
											makes.map((make, idx) =>
											{
												return (
													<option key={idx} value={ make }>{ make }</option>
												)
											})
										}
									</Input>
								</FormGroup>
							</Col>
							<Col md="4">
								<FormGroup>
									<Label htmlFor="models">
										{ t('Vehicles.Search.Models') }
									</Label>
									<Input
										name="models"
										multiple="multiple"
										type="select"
										onChange={ handleModelsChange }
									>
										{
											models.map((model, idx) =>
											{
												return (
													<option key={idx} value={ model }>{ model }</option>
												)
											})
										}
									</Input>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col md="12">
								<Button
									block
									color="primary"
									className="btn-block"
									size="lg"
									onClick={ handleSearchVehicles }
								>
									{ t('Vehicles.Search.Search_Vehicles') }
								</Button>
							</Col>
						</Row>
					</CardBody>
				</Card>
			</Container>
		</>
	)
}

export default BusinessVehiclesSearch
